import React from 'react';

import { SVGProps } from './type';

function Icon(props: SVGProps) {
  const { width = 24, height = 24, color = '#363531' } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M11.74 20.816a9 9 0 100-18 9 9 0 000 18z"
      />
      <path
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M8.74 15.566l3-3 3 3M8.74 10.316l3-3 3 3"
      />
    </svg>
  );
}

export default Icon;
